import * as types from '../constants/types';
import * as globals from '../constants/globals';
import { setSelectedLocationRole } from '../actions/selectedLocationRole';
import { makeAuthorizedRequest } from '../utilities/rest';
import { locationsAreEqual } from '../utilities/locations';
import { doneLoading, startLoading } from './loading';
import { getAccountWithToken } from '../utilities/internalSecurityUtil';

export function fetchChildLocations(location, useInventoryService = true) {
  return async (dispatch) => {
    const apiUrl = useInventoryService ? globals.API_INVENTORY_URL : globals.API_URL;
    const endpoint = `${apiUrl}/location-children?location_id=${encodeURIComponent(
      location.location_id
    )}&location_type=${encodeURIComponent(location.location_type)}`;
    const result = await makeAuthorizedRequest(endpoint, 'GET', dispatch);
    return result.children;
  };
}

export const fetchDomainsForLocationFailure = (error) => ({
  type: types.FETCH_DOMAINS_FOR_LOCATION_ERROR,
  error,
});

export const fetchDomainsForLocationSuccess = (locationId, locDomains) => ({
  type: types.FETCH_DOMAINS_FOR_LOCATION_SUCCESS,
  locationId,
  locDomains,
  error: null,
});

const fetchDomainsForRolesSuccess = (domains) => {
  return {
    type: types.FETCH_DOMAINS_FOR_ROLES_SUCCESS,
    locDomains: domains,
  };
};

export const getDomainsForLocation = (loc, history) => {
  const locKey = `${loc?.location_id}_${loc?.location_type}`;
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const user = state.login.user;

      const url = `${globals.API_URL}/user/${user.user_id}/domains`;
      const response = await makeAuthorizedRequest(url, 'POST', dispatch, { locations: [loc] });

      const accountFromLocalStorage = getAccountWithToken();

      const accountUpdate = Object.assign({}, accountFromLocalStorage, {
        domains_by_location_id: Object.assign(
          {},
          accountFromLocalStorage.domains_by_location_id,
          response.domains_by_location_id
        ),
      });
      window.localStorage.setItem(globals.TOKEN_LOCAL_STORAGE_KEY, JSON.stringify(accountUpdate));

      const domains = response.domains_by_location_id[locKey] ? response.domains_by_location_id[locKey] : null;
      dispatch(fetchDomainsForRolesSuccess(accountUpdate.domains_by_location_id));
      dispatch(fetchDomainsForLocationSuccess(domains.role.location.location_id, response.domains_by_location_id));
      dispatch(setSelectedLocationRole(domains.role, response.domains_by_location_id, history));
    } catch (error) {
      dispatch(fetchDomainsForLocationFailure(error));
    }
  };
};

export const fetchDomainsForRoles = () => {
  return async (dispatch, getState) => {
    dispatch(startLoading());

    try {
      const state = getState();
      const user = state.login.user;

      const locations = [];

      const rolesToCheck = [...user.roles];
      const selectedRole = state.selectedLocationRole && state.selectedLocationRole.role;
      if (selectedRole) {
        const selectedRoleInAssignedRoles =
          rolesToCheck.findIndex((val) => {
            return locationsAreEqual(val.location, selectedRole.location);
          }) !== -1;

        if (!selectedRoleInAssignedRoles) {
          rolesToCheck.push(selectedRole);
        }
      }

      for (const role of rolesToCheck) {
        locations.push(role.location);
      }

      const url = `${globals.API_URL}/user/${user.user_id}/domains`;
      const response = await makeAuthorizedRequest(url, 'POST', dispatch, { locations });

      const accountFromLocalStorage = getAccountWithToken();

      const accountUpdate = Object.assign({}, accountFromLocalStorage, {
        domains_by_location_id: response.domains_by_location_id,
      });
      window.localStorage.setItem(globals.TOKEN_LOCAL_STORAGE_KEY, JSON.stringify(accountUpdate));

      dispatch(fetchDomainsForRolesSuccess(response.domains_by_location_id));
    } catch (error) {
      dispatch(fetchDomainsForLocationFailure(error));
    }

    dispatch(doneLoading());
  };
};
